export const PMSSteps = [
  { order: 1, status: 'Step1PartnerRegistration', title: 'Partner registration' },
  { order: 2, status: 'Step2ApiUserRegistration', title: 'Register API user' },
  {
    order: 3,
    status: 'Step3EmailConfirmationPending',
    title: 'Pending email confirmation'
  },
  { order: 4, status: 'Step4EnvironmentSetup', title: 'Environment setup' },
  { order: 5, status: 'Step5ReviewAndFinalize', title: 'Review and finalize' }
]

export const configLastStepKind = {
  Unknown: 'Unknown',
  Step1PartnerRegistration: 'Step1PartnerRegistration',
  Step2ApiUserRegistration: 'Step2ApiUserRegistration',
  Step3EmailConfirmationPending: 'Step3EmailConfirmationPending',
  Step4EnvironmentSetup: 'Step4EnvironmentSetup',
  Step5ReviewAndFinalize: 'Step5ReviewAndFinalize',
  Step6Completed: 'Step6Completed'
}
